module.exports = __webpack_public_path__ + "img/20.fcc68bc8.png";